import state from './permission.state'
import mutations from './permission.mutations'
import actions from './permission.actions'

export default {
  state,
  mutations,
  actions
}
